import React from "react";
import { useSelector } from "react-redux";
import { ReduxStoreState } from "web/redux/store";
import { ngettext } from "web/script/modules/django-i18n";
import { numberFormat } from "web/script/modules/formats";
import styles from "./feed-count.css";

export interface FeedCountProps {
    productCount: number;
    retailerCount: number;
}

export function FeedCount(props: FeedCountProps): JSX.Element {
    const state = useSelector((state: ReduxStoreState) => state.feedCountReducer);

    const productCount = state.productCount ?? props.productCount;
    const retailerCount = state.retailerCount ?? props.retailerCount;

    return (
        <div className={styles.feedCount}>
            <span>
                {ngettext("feed.product_count.label", "feed.product_count.label_pl", productCount, {
                    count: numberFormat(productCount, 0),
                })}
            </span>
            <span>
                {ngettext(
                    "feed.retailers_count.label",
                    "feed.retailers_count.label_pl",
                    retailerCount,
                    {
                        count: numberFormat(retailerCount, 0),
                    }
                )}
            </span>
        </div>
    );
}

export default FeedCount;
